import { getErrorMessage, logMessage, } from '../utils/helpers';
import { HistoricalData,RequestParams,PeriodParams,BarData,Meta,Bars } from "../models/historical"
import { ResolveSymbolInfo } from '../models/symbolData';
import { trace, context, propagation, SpanStatusCode } from "@opentelemetry/api";
const tracer = trace.getTracer("inhouse-request-tracer");
export class HistoryProvider {
    private _datafeedUrl:string
    private _requester:any
    constructor(datafeedUrl:string, requester:any, headers:any='') {
        this._datafeedUrl = datafeedUrl;
        this._requester = requester;
    }

    //This function returns the historical data of candles 
    getBars(symbolInfo:ResolveSymbolInfo, resolution:string, periodParams:PeriodParams) {
        return tracer.startActiveSpan("GetBars", async (span) => {
            span.setAttributes({
                symbol: symbolInfo.symbol,
                resolution: resolution,
            })
            // Cap countback so the backend never has to serve more than MAX_BARS bars
            // per call. TradingView's UDF flow can request very large countback values on
            // first load (large screens, deep history, resolution switches), which inflates
            // chart-load latency; capping bounds it and TradingView auto-paginates older
            // history with later getBars calls. `from` is left untouched so the server's
            // session-aware logic fills bars correctly across non-trading hours (clamping
            // `from` client-side leaves visible gaps, e.g. 9:15–10:00).
            const MAX_BARS = 1000;
            let countBack = periodParams.countBack || MAX_BARS;
            if (countBack > MAX_BARS) {
                countBack = MAX_BARS;
            }
            const requestParams:RequestParams = {
                symbol: String(symbolInfo.symbol),
                token: String(symbolInfo.odin_token),
                market_segment_id: Number(symbolInfo.odin_market_segment_id),
                resolution: resolution,
                from: periodParams.from,
                to: periodParams.to,
                first_data_request: periodParams.firstDataRequest,
                next_time: true,
                countback: countBack,
                // ADVA-1013 (P7): this build overlays index volume live-side, so
                // the backend may return real (futures-sourced) volume for index
                // history. Builds that omit this get index volume masked to 0.
                supports_index_volume: true,
            };
            if (symbolInfo.currency_code) {
                requestParams.currencyCode = symbolInfo.currency_code;
            }
            if (symbolInfo.unit_id) {
                requestParams.unitId = symbolInfo.unit_id;
            }
            if (requestParams.token == undefined || requestParams.token == 0 || requestParams.token == null || requestParams.token == "" || requestParams.token == "0") {
                return new Promise((resolve, reject) => {
                    const meta:Meta = {
                        noData :true 
                    }
                    let data:Bars={
                        bars: [],
                        meta: meta,
                    }
                    span.setStatus({ code: SpanStatusCode.ERROR });
                    span.end()
                    resolve(data);
                });
            }
            return new Promise((resolve, reject) => {
                this._requester.sendRequest(this._datafeedUrl, 'data/history', requestParams)
                    .then((response:HistoricalData) => {
                    if (response.s !== 'ok' && response.s !== 'no_data') {
                        span.setStatus({ code: SpanStatusCode.ERROR });
                        reject(response.s);
                        span.end()
                        return;
                    }
                    const bars:BarData[] = [];
                    const meta:Meta = {
                        noData: false,
                        nextTime:0,
                    };
                    if (response.s === 'no_data') {
                        meta.noData = true;
                        meta.nextTime = response.next_time;
                    }
                    else if((response.s as string) === "error"){
                        meta.noData = true;
                    }
                    else {
                        const volumePresent = response.v !== undefined;
                        const ohlPresent = response.o !== undefined;
                        var totalLastDayVolumeTillBar = 0
                        if(response.t && response.c && response.o && response.h && response.l && response.v){
                            for (let i = 0; i < response.t?.length; ++i) {
                                const barValue:BarData = {
                                    time: response.t[i] * 1000,
                                    close: Number(response.c[i]),
                                    open: Number(response.c[i]),
                                    high: Number(response.c[i]),
                                    low: Number(response.c[i]),
                                    volume:0,
                                    totalLastDayVolumeTillBar:0
                                };
                                if (ohlPresent) {
                                    barValue.open = Number(response.o[i]);
                                    barValue.high = Number(response.h[i]);
                                    barValue.low = Number(response.l[i]);
                                }
                                if (volumePresent) {
                                    barValue.volume = Number(response.v[i]);
                                    if( barValue.time >= bod()){
                                        totalLastDayVolumeTillBar = totalLastDayVolumeTillBar  + barValue.volume
                                    }
                                    
                                }
                                if( resolution != "1D" && resolution != "1W" && resolution != "1M" &&resolution != "1Y"){
                                    barValue.totalLastDayVolumeTillBar = totalLastDayVolumeTillBar
                                }
                                bars.push(barValue);
                            }
                        }
                    }
                    let data:Bars={
                            bars: bars,
                            meta: meta,
                        }
                    span.end()
                    resolve(data);
                }).catch((reason:any) => {
                    // tslint:disable-next-line:no-console
                    context.with(trace.setSpan(context.active(), span), () => {
                        console.error("Error parsing response:", reason);
                    });
                    span.setStatus({ code: SpanStatusCode.ERROR });
                    span.end()
                    logMessage(`HistoryProvider: getBars() failed, error=${getErrorMessage(reason)}`);
                    reject(reason);
                });
            });
        })
        
       
        
    }
}

function bod(){ //It returns the date and time of current day
    var now = new Date();
    var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var timestamp = startOfDay;
    return Number(timestamp)
}
